import { render, staticRenderFns } from "./PositionAdd.vue?vue&type=template&id=07b3bad5&scoped=true"
import script from "./PositionAdd.vue?vue&type=script&lang=js"
export * from "./PositionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b3bad5",
  null
  
)

export default component.exports